<template>
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.5058 3.03061C30.5438 3.22438 30.5685 3.45805 30.5685 3.7316V28.0039C30.5685 28.2756 30.5438 28.5093 30.5058 28.7049L18.8817 17.5915L17.0732 15.8647L18.8779 14.1378L30.5058 3.03061ZM14.7043 3.03022C14.7423 3.22399 14.767 3.45766 14.767 3.73121V27.9997C14.767 28.2713 14.7423 28.505 14.7043 28.7006L2.80444 17.329C2.68856 17.2169 2.434 16.6964 2.434 15.8643C2.434 15.0323 2.68666 14.5118 2.80824 14.3959L14.7043 3.03022ZM30.7489 0C30.3747 0 29.9909 0.159572 29.6262 0.505338L17.2002 12.3765V3.73111C17.2002 1.55784 16.125 9.73965e-05 14.949 9.73965e-05C14.5748 9.73965e-05 14.1911 0.159669 13.8263 0.505434L1.12698 12.6406C-0.37566 14.0711 -0.37566 17.6595 1.12698 19.0902L13.8244 31.2215C14.1891 31.5673 14.5729 31.7269 14.9471 31.7269C16.1249 31.7269 17.1982 30.171 17.1982 27.9959L17.2001 19.3466L29.6261 31.2275C29.9909 31.5732 30.3746 31.7328 30.7489 31.7328C31.9267 31.7328 33 30.177 33 28.0018V3.7314C33 1.55623 31.9248 0 30.7489 0Z"
      fill="#06D6A0" />
  </svg>
</template>

<script>
export default {
  name: "PrematchIcon",
}
</script>

<style lang="scss" scoped></style>